import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import ChatWidget from "@/components/ChatWidget";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Guide from "@/pages/Guide";
import Intake from "@/pages/Intake";
import Admin from "@/pages/Admin";
import GrowthHub from "@/pages/GrowthHub";
import TechDashboard from "@/pages/TechDashboard";
import CaseWorkspace from "@/pages/CaseWorkspace";
import ChangePassword from "@/pages/ChangePassword";
import PaymentSuccess from "@/pages/PaymentSuccess";
import VaultPage from "@/pages/Vault";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback before any routing/auth checks
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const publicPaths = ["/", "/login", "/register", "/payment-success"];
  const showChat = publicPaths.includes(location.pathname);
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
        />
        <Route
          path="/guide"
          element={<ProtectedRoute><Guide /></ProtectedRoute>}
        />
        <Route
          path="/vault"
          element={<ProtectedRoute><VaultPage /></ProtectedRoute>}
        />
        <Route
          path="/intake"
          element={<ProtectedRoute><Intake /></ProtectedRoute>}
        />
        <Route
          path="/admin"
          element={<ProtectedRoute><Admin /></ProtectedRoute>}
        />
        <Route
          path="/admin/growth"
          element={<ProtectedRoute><GrowthHub /></ProtectedRoute>}
        />
        <Route
          path="/tech"
          element={<ProtectedRoute><TechDashboard /></ProtectedRoute>}
        />
        <Route
          path="/staff/case/:caseId"
          element={<ProtectedRoute><CaseWorkspace /></ProtectedRoute>}
        />
        <Route
          path="/change-password"
          element={<ProtectedRoute><ChangePassword /></ProtectedRoute>}
        />
      </Routes>
      {showChat && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
